import { environment } from "src/environments/environment";

export abstract class GetDate {
  static amount = environment.amountToSkewDate;

  static getDate(): Date {
    let date = new Date();
    if (environment.skewDate) {
      // 5 years is 157680000000 milliseconds
      date = new Date(date.getTime() - this.amount);
    }
    return date;
  }

  static skewDate(date: Date): Date {
    const skewedDate = new Date(date.getTime() - this.amount);
    return skewedDate;
  }

  static unskewDate(date: Date): Date {
    const unskewedDate = new Date(date.getTime() + this.amount);
    return unskewedDate;
  }

  static automaticSkewDate(date: Date): Date {
    if (environment.skewDate) {
      // 5 years is 157680000000 milliseconds
      date = new Date(date.getTime() - this.amount);
    }
    return date;
  }

  static automaticUnSkewDate(date: Date): Date {
    if (environment.skewDate) {
      // 5 years is 157680000000 milliseconds
      date = new Date(date.getTime() + this.amount);
    }
    return date;
  }

  static unskewDailyData(data) {
    data.forEach(element => {
      element.date = GetDate.automaticUnSkewDate(new Date(element.date));
      element.end = GetDate.automaticUnSkewDate(new Date(element.end));
    });
    return data
  }

  static unskewMapData(data) {
    if (data.length > 0) {
      data.forEach(element => {
        element.date = GetDate.automaticUnSkewDate(new Date(element.date));
      });
    } else {
      data.date = GetDate.automaticUnSkewDate(new Date(data.date));
    }
    return data
  }

  static unskewDateObjectData(data) {
    if (data.length > 0) {
      data.forEach(element => {
        element.date = GetDate.automaticUnSkewDate(new Date(element.date));
      });
    } else {
      data.date = GetDate.automaticUnSkewDate(new Date(data.date));
    }
    return data
  }
}
